module.exports = __webpack_public_path__ + "img/rock_fire_icon.d47c802f.png";